module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1008-a8416e734cb6f64fcdf6c910986f4b11.png";